function floatingCartBtn() {
  const quantity = document.getElementById("bottom_bar_quantity").value;
  const id = document.getElementById("product-id").value;
  let formData = {
    items: [
      {
        id: id,
        quantity: quantity,
      },
    ],
  };

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (response.ok) {
        // Item added to the cart successfully
        // You can redirect to another page here
        window.location.href = "/cart"; // Replace with your desired URL
      } else {
        console.error("Error:", response.statusText);
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
